// @flow
import { vehicleModel } from 'common/middleware/api';
import { ApiError } from 'common/modules/api';
import { injectError } from 'common/redux/actions/error';
import { VehicleModel } from 'common/models/internal/Plan';

export default class VehicleActions {
    static SET_IS_FETCHING_VEHICLE_MODELS_IN_PROGRESS: string =
        'SET_IS_FETCHING_VEHICLE_MODELS_IN_PROGRESS';
    static INJECT_VEHICLE_MODELS: string = 'INJECT_VEHICLE_MODELS';

    static fetchVehicleModels(clientId: string): Object {
        return dispatch => {
            dispatch(
                VehicleActions.setIsFetchingVehicleModelsInProgress(
                    clientId,
                    true
                )
            );
            return vehicleModel
                .fetch({
                    clientId
                })
                .then(vehicleModels => {
                    dispatch(
                        VehicleActions.injectVehicleModels(
                            clientId,
                            vehicleModels
                        )
                    );
                })
                .catch(error => {
                    dispatch(
                        VehicleActions.setIsFetchingVehicleModelsInProgress(
                            clientId,
                            false
                        )
                    );
                    if (error instanceof ApiError) {
                        dispatch(injectError(error));
                    } else {
                        throw error;
                    }
                });
        };
    }

    static setIsFetchingVehicleModelsInProgress(
        clientId: string,
        isFetchingVehicleModelsInProgress: boolean
    ): Object {
        return {
            type: VehicleActions.SET_IS_FETCHING_VEHICLE_MODELS_IN_PROGRESS,
            response: isFetchingVehicleModelsInProgress,
            params: {
                clientId
            }
        };
    }

    static injectVehicleModels(
        clientId: string,
        vehicleModels: Array<VehicleModel>
    ): Object {
        return {
            type: VehicleActions.INJECT_VEHICLE_MODELS,
            response: vehicleModels,
            params: {
                clientId
            }
        };
    }
}
